import { render, staticRenderFns } from "./VideoLibraries.vue?vue&type=template&id=23660860&scoped=true"
import script from "./VideoLibraries.vue?vue&type=script&lang=js"
export * from "./VideoLibraries.vue?vue&type=script&lang=js"
import style0 from "./VideoLibraries.vue?vue&type=style&index=0&id=23660860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23660860",
  null
  
)

export default component.exports